import {Component, ViewChild} from '@angular/core';
import {Nav, Platform, App} from 'ionic-angular';
import {UserAuthenticationService} from './user/login/services/user-authentication.service';

/**
 * Base App
 * @class
 */
@Component({
  templateUrl: 'app.html',
})
export class MyApp {
  /**
   * Gets the nav element from the template
   */
  @ViewChild(Nav)
  nav: Nav;

  /**
   * Sets the root page
   * @type {string}
   */
  rootPage: any = 'LoginPage';

  /**
   * Sets the pages array for the side menu
   */
  pages: Array<{ title: string, component: any }>;

  /**
   * @constructor
   * @param {Platform} platform the Platform instance
   * @param {UserAuthenticationService} userAuthService the UserAuthenticationService instance
   * @param {App} app the App instance
   */
  constructor(public platform: Platform,
              public userAuthService: UserAuthenticationService,
              public app: App) {
    this.pages = [
      {title: 'My Recent', component: 'MyRecentListingPage'},
      {title: 'All Articles', component: 'ArticleListingPage'},
      {title: 'All Images', component: 'ImageListingPage'},
      {title: 'All Videos', component: 'VideoListingPage'},
    ];
    this.initializeApp();
  }

  /**
   * Initializes the app
   * Generated by ionic
   * @returns {void}
   */
  initializeApp(): void {
    this.platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
    });
  }

  /**
   * Handles clicking from the side menu opens the page
   * @param {any} page the page to be opened from the left nav menu
   * @returns {Promise<any>}
   */
  openPage(page): Promise<any> {
    // Reset the content nav to have just this page
    // we wouldn't want the back button to show in this scenario
    return this.nav.setRoot(page.component);
  }

  /**
   * logs the user out
   * @returns {void}
   */
  logout(): void {

    this.userAuthService.logout().subscribe(
      (res) => {
        localStorage.removeItem('username');
        localStorage.removeItem('displayName');
        this.app.getRootNav().setRoot('LoginPage');
      },
    );

  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts